export const allStatus = {
  inprocess: {
    statusCode: 1,
    tagColor: '#ad3c2c',
    fontColor: '#f23030',
    autoMobileBgc: 'linear-gradient(90deg, #f96e6e 0%, #e13030 100%)',
    msg: '进行中',
  },
  preannounce: {
    statusCode: 0,
    tagColor: '#558b67',
    fontColor: '#268e66',
    autoMobileBgc: 'linear-gradient(90deg, #65ddb5 0%, #479e91 100%)',
    msg: '预告中',
  },
  end: {
    statusCode: 2,
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    autoMobileBgc: 'linear-gradient(90deg, #959595 0%, #5b5e65 100%)',
    msg: '已结束',
  },
  respite: {
    statusCode: 6,
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    autoMobileBgc: 'linear-gradient(90deg, #959595 0%, #5b5e65 100%)',
    msg: '已暂缓',
  },
  stop: {
    statusCode: 7,
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    autoMobileBgc: 'linear-gradient(90deg, #959595 0%, #5b5e65 100%)',
    msg: '已中止',
  },
  withdraw: {
    statusCode: 5,
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    autoMobileBgc: 'linear-gradient(90deg, #959595 0%, #5b5e65 100%)',
    msg: '已撤回',
  },
  nodata: {
    statusCode: -1,
    tagColor: '#fff',
    fontColor: '#fff',
    autoMobileBgc: '',
    msg: '',
  },
}


export const Mode = {
  promotion: 'promotion',
  competition: 'competition',
};

export const getStatus = ( displayStatus, auctionStatus ) => {
  let status = 'nodata';
  if ( Number(displayStatus) === 1 ) {
    switch ( auctionStatus ) {
      case 1:
        status = 'inprocess';
        break;
      case 2:
        status = 'end';
        break;
      case 0:
        status = 'preannounce';
        break;
    }
  } else {
    switch ( Number(displayStatus) ) {
      case 3:
        if ( Number(auctionStatus) === 1 ) {
          status = 'respite';
        } else {
          status = 'end';
        }
        break;
      case 5:
        status = 'withdraw';
        break;
      case 6:
        status = 'respite';
        break;
      case 7:
        status = 'stop';
        break;
    }
  }
  return status;
}

export const ProvinceItems = [
  {id: '', name: '全国'},
  {id: '1', name: '北京'},
  {id: '2', name: '上海'},
  {id: '3', name: '天津'},
  {id: '4', name: '重庆'},
  {id: '5', name: '河北'},
  {id: '6', name: '山西'},
  {id: '7', name: '河南'},
  {id: '8', name: '辽宁'},
  {id: '9', name: '吉林'},
  {id: '10', name: '黑龙江'},
  {id: '11', name: '内蒙古'},
  {id: '12', name: '江苏'},
  {id: '13', name: '山东'},
  {id: '14', name: '安徽'},
  {id: '15', name: '浙江'},
  {id: '16', name: '福建'},
  {id: '17', name: '湖北'},
  {id: '18', name: '湖南'},
  {id: '19', name: '广东'},
  {id: '20', name: '广西'},
  {id: '21', name: '江西'},
  {id: '22', name: '四川'},
  {id: '23', name: '海南'},
  {id: '24', name: '贵州'},
  {id: '25', name: '云南'},
  {id: '26', name: '西藏'},
  {id: '27', name: '陕西'},
  {id: '28', name: '甘肃'},
  {id: '29', name: '青海'},
  {id: '30', name: '宁夏'},
  {id: '31', name: '新疆'},
  {id: '52993', name: '港澳'},
  {id: '32', name: '台湾'},
  {id: '84', name: '钓鱼岛'}
]

export const CityObj = {
  "1": "朝阳区|72,海淀区|2800,西城区|2801,东城区|2802,崇文区|2803,宣武区|2804,丰台区|2805,石景山区|2806,门头沟|2807,房山区|2808,通州区|2809,大兴区|2810,顺义区|2812,怀柔区|2814,密云区|2816,昌平区|2901,平谷区|2953,延庆县|3065",
  "2": "徐汇区|2813,长宁区|2815,静安区|2817,闸北区|2820,虹口区|2822,杨浦区|2823,宝山区|2824,闵行区|2825,嘉定区|2826,浦东新区|2830,青浦区|2833,松江区|2834,金山区|2835,奉贤区|2837,普陀区|2841,崇明县|2919,黄浦区|78",
  "3": "东丽区|51035,和平区|51036,河北区|51037,河东区|51038,河西区|51039,红桥区|51040,蓟县|51041,静海县|51042,南开区|51043,塘沽区|51044,西青区|51045,武清区|51046,津南区|51047,汉沽区|51048,大港区|51049,北辰区|51050,宝坻区|51051,宁河县|51052",
  "4": "万州区|113,涪陵区|114,梁平县|115,南川区|119,潼南县|123,大足区|126,黔江区|128,武隆县|129,丰都县|130,奉节县|131,开县|132,云阳县|133,忠县|134,巫溪县|135,巫山县|136,石柱县|137,彭水县|138,垫江县|139,酉阳县|140,秀山县|141,璧山县|48131,荣昌县|48132,铜梁县|48133,合川区|48201,巴南区|48202,北碚区|48203,江津区|48204,渝北区|48205,长寿区|48206,永川区|48207,江北区|50950,南岸区|50951,九龙坡区|50952,沙坪坝区|50953,大渡口区|50954,綦江区|50995,渝中区|51026,高新区|51027,北部新区|51028,城口县|4164",
  "5": "石家庄市|142,邯郸市|148,邢台市|164,保定市|199,张家口市|224,承德市|239,秦皇岛市|248,唐山市|258,沧州市|264,廊坊市|274,衡水市|275",
  "6": "太原市|303,大同市|309,阳泉市|318,晋城市|325,朔州市|330,晋中市|336,忻州市|350,吕梁市|368,临汾市|379,运城市|398,长治市|3074",
  "7": "郑州市|412,开封市|420,洛阳市|427,平顶山市|438,焦作市|446,鹤壁市|454,新乡市|458,安阳市|468,濮阳市|475,许昌市|482,漯河市|489,三门峡市|495,南阳市|502,商丘市|517,周口市|527,驻马店市|538,信阳市|549,济源市|2780",
  "8": "沈阳市|560,大连市|573,鞍山市|579,抚顺市|584,本溪市|589,丹东市|593,锦州市|598,葫芦岛市|604,营口市|609,盘锦市|613,阜新市|617,辽阳市|621,朝阳市|632,铁岭市|6858",
  "9": "长春市|639,吉林市|644,四平市|651,辽源市|2992,通化市|657,白山市|664,松原市|674,白城市|681,延边州|687",
  "10": "鹤岗市|727,双鸭山市|731,鸡西市|737,大庆市|742,伊春市|753,牡丹江市|757,佳木斯市|765,七台河市|773,黑河市|776,绥化市|782,大兴安岭地区|793,哈尔滨市|698,齐齐哈尔市|712",
  "11": "呼和浩特市|799,包头市|805,乌海市|810,赤峰市|812,乌兰察布市|823,锡林郭勒盟|835,呼伦贝尔市|848,鄂尔多斯市|870,巴彦淖尔市|880,阿拉善盟|891,兴安盟|895,通辽市|902",
  "12": "南京市|904,徐州市|911,连云港市|919,淮安市|925,宿迁市|933,盐城市|939,扬州市|951,泰州市|959,南通市|965,镇江市|972,常州市|978,无锡市|984,苏州市|988",
  "13": "济宁市|2900,济南市|1000,青岛市|1007,淄博市|1016,枣庄市|1022,东营市|1025,潍坊市|1032,烟台市|1042,威海市|1053,莱芜市|1058,德州市|1060,临沂市|1072,聊城市|1081,滨州市|1090,菏泽市|1099,日照市|1108,泰安市|1112",
  "14": "黄山市|1151,滁州市|1159,阜阳市|1167,亳州市|1174,宿州市|1180,池州市|1201,六安市|1206,宣城市|2971,铜陵市|1114,合肥市|1116,淮南市|1121,淮北市|1124,芜湖市|1127,蚌埠市|1132,马鞍山市|1137,安庆市|1140",
  "15": "宁波市|1158,衢州市|1273,丽水市|1280,台州市|1290,舟山市|1298,杭州市|1213,温州市|1233,嘉兴市|1243,湖州市|1250,绍兴市|1255,金华市|1262",
  "16": "福州市|1303,厦门市|1315,三明市|1317,莆田市|1329,泉州市|1332,漳州市|1341,南平市|1352,龙岩市|1362,宁德市|1370",
  "17": "孝感市|1432,黄冈市|1441,咸宁市|1458,恩施州|1466,鄂州市|1475,荆门市|1477,随州市|1479,神农架林区|3154,武汉市|1381,黄石市|1387,襄阳市|1396,十堰市|1405,荆州市|1413,宜昌市|1421,潜江市|2922,天门市|2980,仙桃市|2983",
  "18": "长沙市|1482,株洲市|1488,湘潭市|1495,衡阳市|1501,邵阳市|1511,岳阳市|1522,常德市|1530,张家界市|1540,郴州市|1544,益阳市|1555,永州市|1560,怀化市|1574,娄底市|1586,湘西州|1592",
  "19": "广州市|1601,深圳市|1607,珠海市|1609,汕头市|1611,韶关市|1617,河源市|1627,梅州市|1634,揭阳市|1709,惠州市|1643,汕尾市|1650,东莞市|1655,中山市|1657,江门市|1659,佛山市|1666,阳江市|1672,湛江市|1677,茂名市|1684,肇庆市|1690,云浮市|1698,清远市|1704,潮州市|1705",
  "20": "崇左市|3168,南宁市|1715,柳州市|1720,桂林市|1726,梧州市|1740,北海市|1746,防城港市|1749,钦州市|1753,贵港市|1757,玉林市|1761,贺州市|1792,百色市|1806,河池市|1818,来宾市|3044",
  "21": "南昌市|1827,景德镇市|1832,萍乡市|1836,新余市|1842,九江市|1845,鹰潭市|1857,上饶市|1861,宜春市|1874,抚州市|1885,吉安市|1898,赣州市|1911",
  "22": "凉山州|2103,成都市|1930,自贡市|1946,攀枝花市|1950,泸州市|1954,绵阳市|1960,德阳市|1962,广元市|1977,遂宁市|1983,内江市|1988,乐山市|1993,宜宾市|2005,广安市|2016,南充市|2022,达州市|2033,巴中市|2042,雅安市|2047,眉山市|2058,资阳市|2065,阿坝州|2070,甘孜州|2084",
  "23": "三亚市|3690,文昌市|3698,五指山市|3699,临高县|3701,澄迈县|3702,定安县|3703,屯昌县|3704,昌江县|3705,白沙县|3706,琼中县|3707,陵水县|3708,保亭县|3709,乐东县|3710,三沙市|3711,海口市|2121,琼海市|3115,万宁市|3137,东方市|3173,儋州市|3034",
  "24": "贵阳市|2144,六盘水市|2150,遵义市|2155,铜仁市|2169,毕节市|2180,安顺市|2189,黔西南州|2196,黔东南州|2205,黔南州|2222",
  "25": "迪庆州|4108,昆明市|2235,曲靖市|2247,玉溪市|2258,昭通市|2270,普洱市|2281,临沧市|2291,保山市|2298,丽江市|2304,文山州|2309,红河州|2318,西双版纳州|2332,楚雄州|2336,大理州|2347,德宏州|2360,怒江州|2366",
  "26": "阿里地区|3970,林芝地区|3971,拉萨市|2951,那曲地区|3107,山南地区|3129,昌都地区|3138,日喀则地区|3144",
  "27": "延安市|2428,汉中市|2442,榆林市|2454,商洛市|2468,安康市|2476,西安市|2376,铜川市|2386,宝鸡市|2390,咸阳市|2402,渭南市|2416",
  "28": "庆阳市|2525,陇南市|2534,武威市|2544,张掖市|2549,酒泉市|2556,甘南州|2564,临夏州|2573,定西市|3080,兰州市|2487,金昌市|2492,白银市|2495,天水市|2501,嘉峪关市|2509,平凉市|2518",
  "29": "西宁市|2580,海东地区|2585,海北州|2592,黄南州|2597,海南州|2603,果洛州|2605,玉树州|2612,海西州|2620",
  "30": "银川市|2628,石嘴山市|2632,吴忠市|2637,固原市|2644,中卫市|3071",
  "31": "铁门关市|53090,五家渠市|4110,阿拉尔市|15945,图木舒克市|15946,乌鲁木齐市|2652,克拉玛依市|2654,石河子市|2656,吐鲁番地区|2658,哈密地区|2662,和田地区|2666,阿克苏地区|2675,喀什地区|2686,克孜勒苏州|2699,巴音郭楞州|2704,昌吉州|2714,博尔塔拉州|2723,伊犁州|2727,塔城地区|2736,阿勒泰地区|2744",
  "32": "台湾|2768",
  "84": "钓鱼岛|1310",
  "52993": "香港特别行政区|52994,澳门特别行政区|52995"
}

export const bankRuptcyMore = {
  AuctionStatus: [
    {id: -1, name: '全部', condition: {paimaiStatus: 'none', displayStatus: 'none'}},
    {id: 1, name: '进行中', condition: {paimaiStatus: 1}},
    {id: 0, name: '预告中', condition: {paimaiStatus: 0}},
    {id: 2, name: '已结束', condition: {paimaiStatus: 2}},
    {id: 6, name: '已暂缓', condition: {displayStatus: 6}},
    {id: 7, name: '已中止', condition: {displayStatus: 7}},
    {id: 5, name: '已撤回', condition: {displayStatus: 5}},
  ],
  PromotionAuctionStatus: [
    {id: -1, name: '全部', comparativeValue: '', condition: {paimaiStatus: 'none', displayStatus: 'none', merchantsStatus: 'none'}, mode: 'all'},
    {id: 1, name: '进行中', comparativeValue: 1, condition: {paimaiStatus: 1}, mode: Mode.competition},
    {id: 0, name: '预告中', comparativeValue: 0, condition: {paimaiStatus: 0}, mode: Mode.competition},
    {id: 2, name: '已结束', comparativeValue: 2, condition: {paimaiStatus: 2}, mode: Mode.competition},
    {id: 6, name: '已暂缓', comparativeValue: 6, condition: {displayStatus: 6}, mode: Mode.competition},
    {id: 7, name: '已中止', comparativeValue: 7, condition: {displayStatus: 7}, mode: Mode.competition},
    {id: 5, name: '已撤回', comparativeValue: 5, condition: {displayStatus: 5}, mode: Mode.competition},
    {id: 8, name: '招商中', comparativeValue: [1], condition: {merchantsStatus: [1]}, mode: Mode.promotion},
    {id: 9, name: '招商结束', comparativeValue: [2, 3], condition: {merchantsStatus: [2, 3]}, mode: Mode.promotion},
  ],
  SubjectCharacteristics: [
    {id: 0, name: '不限购'},
    {id: 1, name: '可贷款'},
  ],
}

// 资产机构-标的排序
export const assetTargetSort = [
  {
    id: '',
    name: '默认排序',
    selected: true,
    index: 4,
    condition: {sortField: '8'},
  },
  {
    id: 0,
    name: '开始时间升序',
    selected: false,
    index: 4,
    condition: {sortField: "0"},
  },
  {
    id: 3,
    name: '开始时间降序',
    selected: false,
    index: 4,
    condition: {sortField: "3"},
  },
  {
    id: 2,
    name: '结束时间升序',
    selected: false,
    index: 4,
    condition: {sortField: "2"},
  },
  {
    id: 9,
    name: '结束时间降序',
    selected: false,
    index: 4,
    condition: {sortField: "9"},
  },
];

// 资产机构-标的分类
export const assetTargetClassify = [
  {
    name: '不限',
    param: 0,
    actived: true,
    condition: {childrenCateId: 'none'},
  },
  {
    name: '房产',
    param: 12762,
    actived: false,
    condition: {childrenCateId: "12762"},
  },
  {
    name: '交通运输',
    param: 12763,
    actived: false,
    condition: {childrenCateId: "12763"},
  },
  {
    name: '土地林权',
    param: 12764,
    actived: false,
    condition: {childrenCateId: "12764"},
  },
  {
    name: '股权',
    param: 12766,
    actived: false,
    condition: {childrenCateId: "12766"},
  },
  {
    name: '债权',
    param: 12767,
    actived: false,
    condition: {childrenCateId: "12767"},
  },
  {
    name: '机械设备',
    param: 12765,
    actived: false,
    condition: {childrenCateId: "12765"},
  },
  {
    name: '无形资产',
    param: 12769,
    actived: false,
    condition: {childrenCateId: "12769"},
  },
  {
    name: '知识产权',
    param: 12768,
    actived: false,
    condition: {childrenCateId: "12768"},
  },
  {
    name: '其他资产',
    param: 13129,
    actived: false,
    condition: {childrenCateId: "13129"},
  },
];

// 资产机构-标的所在地
export const assetTargetLocations = [
  {
    id: '',
    name: '不限',
    selected: true,
    condition: {provinceId: 'none'},
  },
  {
    id: 1,
    name: '北京',
    selected: false,
    condition: {provinceId: '1'},
  },
  {
    id: 2,
    name: '上海',
    selected: false,
    condition: {provinceId: '2'},
  },
  {
    id: 3,
    name: '天津',
    selected: false,
    condition: {provinceId: '3'},
  },
  {
    id: 4,
    name: '重庆',
    selected: false,
    condition: {provinceId: '4'},
  },
  {
    id: 5,
    name: '河北',
    selected: false,
    condition: {provinceId: '5'},
  },
  {
    id: 6,
    name: '山西',
    selected: false,
    condition: {provinceId: '6'},
  },
  {
    id: 7,
    name: '河南',
    selected: false,
    condition: {provinceId: '7'},
  },
  {
    id: 8,
    name: '辽宁',
    selected: false,
    condition: {provinceId: '8'},
  },
  {
    id: 9,
    name: '吉林',
    selected: false,
    condition: {provinceId: '9'},
  },
  {
    id: 10,
    name: '黑龙江',
    selected: false,
    condition: {provinceId: '10'},
  },
  {
    id: 11,
    name: '内蒙古',
    selected: false,
    condition: {provinceId: '11'},
  },
  {
    id: 12,
    name: '江苏',
    selected: false,
    condition: {provinceId: '12'},
  },
  {
    id: 13,
    name: '山东',
    selected: false,
    condition: {provinceId: '13'},
  },
  {
    id: 14,
    name: '安徽',
    selected: false,
    condition: {provinceId: '14'},
  },
  {
    id: 15,
    name: '浙江',
    selected: false,
    condition: {provinceId: "15"},
  },
  {
    id: 16,
    name: '福建',
    selected: false,
    condition: {provinceId: "16"},
  },
  {
    id: 17,
    name: '湖北',
    selected: false,
    condition: {provinceId: "17"},
  },
  {
    id: 18,
    name: '湖南',
    selected: false,
    condition: {provinceId: "18"},
  },
  {
    id: 19,
    name: '广东',
    selected: false,
    condition: {provinceId: "19"},
  },
  {
    id: 20,
    name: '广西',
    selected: false,
    condition: {provinceId: "20"},
  },
  {
    id: 21,
    name: '江西',
    selected: false,
    condition: {provinceId: "21"},
  },
  {
    id: 22,
    name: '四川',
    selected: false,
    condition: {provinceId: "22"},
  },
  {
    id: 23,
    name: '海南',
    selected: false,
    condition: {provinceId: "23"},
  },
  {
    id: 24,
    name: '贵州',
    selected: false,
    condition: {provinceId: "24"},
  },
  {
    id: 25,
    name: '云南',
    selected: false,
    condition: {provinceId: "25"},
  },
  {
    id: 26,
    name: '西藏',
    selected: false,
    condition: {provinceId: "26"},
  },
  {
    id: 27,
    name: '陕西',
    selected: false,
    condition: {provinceId: "27"},
  },
  {
    id: 28,
    name: '甘肃',
    selected: false,
    condition: {provinceId: "28"},
  },
  {
    id: 29,
    name: '青海',
    selected: false,
    condition: {provinceId: "29"},
  },
  {
    id: 30,
    name: '宁夏',
    selected: false,
    condition: {provinceId: "30"},
  },
  {
    id: 31,
    name: '新疆',
    selected: false,
    condition: {provinceId: "31"},
  },
];

// 资产机构-标的更多
export const assetTargetAuctionStatus = [
  {
    id: '',
    name: '不限',
    selected: true,
    condition: {paimaiStatus: 'none'},
    conditionHaiGuan: {multiPaimaiStatus: 'none'},
  },
  {
    id: 1,
    name: '进行中',
    selected: false,
    condition: {paimaiStatus: "1"},
    conditionHaiGuan: {multiPaimaiStatus: "1"},
  },
  {
    id: 0,
    name: '预告中',
    selected: false,
    condition: {paimaiStatus: "0"},
    conditionHaiGuan: {multiPaimaiStatus: "0"},
  },
  {
    id: 2,
    name: '已结束',
    selected: false,
    condition: {paimaiStatus: "2"},
    conditionHaiGuan: {multiPaimaiStatus: "2"},
  },
];

// 资产机构-推介排序
export const assetPromotionSort = [
  {
    id: 1,
    name: '默认排序',
    selected: true,
    condition: {sortType: 1},
  },
  {
    id: 4,
    name: '价值由低到高',
    selected: false,
    condition: {sortType: 4},
  },
  {
    id: 3,
    name: '价值由高到低',
    selected: false,
    condition: {sortType: 3},
  },
];

// 资产机构-推介类型
export const assetPromotionClassify = [
  {
    name: '不限',
    param: 0,
    selected: true,
    condition: {categoryIds: 'none'},
  },
  {
    name: '房产',
    param: 12762,
    selected: false,
    condition: {categoryIds: [12762]},
  },
  {
    name: '交通运输',
    param: 12763,
    selected: false,
    condition: {categoryIds: [12763]},
  },
  {
    name: '土地林权',
    param: 12764,
    selected: false,
    condition: {categoryIds: [12764]},
  },
  {
    name: '股权',
    param: 12766,
    selected: false,
    condition: {categoryIds: [12766]},
  },
  {
    name: '债权',
    param: 12767,
    selected: false,
    condition: {categoryIds: [12767]},
  },
  {
    name: '机械设备',
    param: 12765,
    selected: false,
    condition: {categoryIds: [12765]},
  },
  {
    name: '无形资产',
    param: 12769,
    selected: false,
    condition: {categoryIds: [12769]},
  },
  {
    name: '知识产权',
    param: 12768,
    selected: false,
    condition: {categoryIds: [12768]},
  },
  {
    name: '其他资产',
    param: 13129,
    selected: false,
    condition: {categoryIds: [13129]},
  },
];

// 资产机构-推介更多
export const promotionMore = {
  noticeStatus: [
    {
      merchantsStatus: [-1],
      text: '全部',
      selected: true,
      condition: {merchantsStatus: 'none'},
    }, {
      merchantsStatus: [1],
      text: '招商中',
      selected: false,
      condition: {merchantsStatus: [1]},
    }, {
      merchantsStatus: [2, 3],
      text: '招商结束',
      selected: false,
      condition: {merchantsStatus: [2,3]},
    },
  ],
  referenceValue: [
    {
      referenceLowerLimit: 'none',
      referenceUpperLimit: 'none',
      text: '全部',
      selected: true,
      condition: {referenceLowerLimit: 'none',referenceUpperLimit: 'none'},
    },
    {
      referenceLowerLimit: 0,
      referenceUpperLimit: 4999999,
      text: '500万以下',
      selected: false,
      condition: {referenceLowerLimit: '',referenceUpperLimit: '4999999'},
    },
    {
      referenceLowerLimit: 5000000,
      referenceUpperLimit: 14999999,
      text: '500-1500万',
      selected: false,
      condition: {referenceLowerLimit: '5000000',referenceUpperLimit: '14999999'},
    },
    {
      referenceLowerLimit: 15000000,
      referenceUpperLimit: 24999999,
      text: '1500-2500万',
      selected: false,
      condition: {referenceLowerLimit: '15000000',referenceUpperLimit: '24999999'},
    },
    {
      referenceLowerLimit: 25000000,
      referenceUpperLimit: 34999999,
      text: '2500-3500万',
      selected: false,
      condition: {referenceLowerLimit: '25000000',referenceUpperLimit: '34999999'},
    },
    {
      referenceLowerLimit: 35000000,
      referenceUpperLimit: 49999999,
      text: '3500-5000万',
      selected: false,
      condition: {referenceLowerLimit: '35000000',referenceUpperLimit: '49999999'},
    },
    {
      referenceLowerLimit: 50000000,
      referenceUpperLimit: 0,
      text: '5000万以上',
      selected: false,
      condition: {referenceLowerLimit: '50000000',referenceUpperLimit: ''},
    },
  ],
};

// 拍品显示状态，优先于拍品状态
export const DISPLAY_STATUS_MAPPING = {
  3: 'pause', // 撤回
  5: 'widthdraw', // 撤回
  6: 'postpone',  // 暂缓
  7: 'suspend'    // 中止
};

// 资产机构-标的列表拍卖状态样式
export const targetAllStatus = {
  pause: {
    statusCode: '3_display',
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    msg: '已暂停',
  },
  widthdraw: {
    statusCode: '5_display',
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    msg: '已撤回',
  },
  postpone: {
    statusCode: '6_display',
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    msg: '已暂缓',
  },
  suspend: {
    statusCode: '7_display',
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    msg: '已中止',
  },
  inprocess: {
    statusCode: 1,
    tagColor: '#ad3c2c',
    fontColor: '#f23030',
    msg: '进行中',
  },
  preannounce: {
    statusCode: 0,
    tagColor: '#558b67',
    fontColor: '#268e66',
    msg: '预告中',
  },
  inprocess_listToAuction: {
    statusCode: '1_LTA',
    tagColor: '#ad3c2c',
    fontColor: '#f23030',
    msg: '开始时间'
  },
  preannounce_listToAuction: {
    statusCode: '0_LTA',
    tagColor: '#558b67',
    fontColor: '#268e66',
    msg: '资质审核'
  },
  end: {
    statusCode: 2,
    tagColor: '#8a8a8a',
    fontColor: '#8a8a8a',
    msg: '已结束',
  },
  nodata: {
    statusCode: -1,
    tagColor: '#fff',
    fontColor: '#fff',
    msg: '',
  },
};

// 资产机构-获取标的列表拍卖状态
export const getStatusTarget = (displayStatus, auctionStatus, listToAuction) => {
  let status = 'nodata';

  if (!!DISPLAY_STATUS_MAPPING[displayStatus])
    return DISPLAY_STATUS_MAPPING[displayStatus];

  switch (auctionStatus) {
    // 广交所：进行中的拍品只展示开始时间
    case 1:
      status = !listToAuction ? 'inprocess' : 'inprocess_listToAuction';
      break;
    case 2:
      status = 'end';
      break;
    // 广交所：预告中的拍品，未同步开始时间时展示资质审核截止时间
    case 0:
      status = (listToAuction !== 1) ? 'preannounce' : 'preannounce_listToAuction';
      break;
    default:
      status = 'nodata';
      break;
  }
  return status;
}


// 破产推介卡片状态
export const MAP_MERCHANTS_STATUS = {
  1: {
    TEXT:'招商中',
    BGC: '#C71622',
    FC: '#C71622',
  },
  2: {
    TEXT:'已转竞价',
    BGC: '#AA8360',
    FC: '#AA8360',
  },
  // 2021.01.20 状态修改为 招商结束
  3: {
    TEXT:'招商结束',
    BGC: '#8A8A8A',
    FC: '#8A8A8A',
  },
  4: {
    TEXT:'已关闭',
    BGC: '#8A8A8A',
    FC: '#8A8A8A',
  }
}

// 破产-投资人招募排序
export const investorsRecruitSort = [
  {
    id: 1,
    name: '默认排序',
    selected: true,
    condition: {sortType: 1},
  },
  {
    id: 4,
    name: '参考价值由低到高',
    selected: false,
    condition: {sortType: 4},
  },
  {
    id: 3,
    name: '参考价值由高到低',
    selected: false,
    condition: {sortType: 3},
  },
  {
    id: 7,
    name: '意向人数从高到低',
    selected: false,
    condition: {sortType: 7},
  },
  {
    id: 8,
    name: '意向人数从低到高',
    selected: false,
    condition: {sortType: 8},
  },
  {
    id: 10,
    name: '发布时间升序',
    selected: false,
    condition: {sortType: 10},
  },
  {
    id: 9,
    name: '发布时间降序',
    selected: false,
    condition: {sortType: 9},
  }
];

// 破产-机构选聘排序
export const mechanismSelectionSort = [
  {
    id: '1',
    name: '默认排序',
    selected: true,
    condition: {publishTimeSort: '1', deadLineSort: '1'},
  },
  {
    id: '1',
    name: '发布时间倒序',
    selected: false,
    condition: {publishTimeSort: '1'},
  },
  {
    id: '2',
    name: '发布时间正序',
    selected: false,
    condition: {publishTimeSort: '2'},
  },
  {
    id: '3',
    name: '申报期限升序',
    selected: false,
    condition: {deadLineSort: '2'},
  },
  {
    id: '4',
    name: '申报期限降序',
    selected: false,
    condition: {deadLineSort: '1'},
  },
];

// 破产-机构选聘更多
export const mechanismSelectionMore = {
  noticeStatus: [
    {
      announcementStatus: '',
      text: '不限',
      selected: true,
      condition: {announcementStatus: 'none'},
    }, {
      announcementStatus: 20,
      text: '公告中',
      selected: false,
      condition: {announcementStatus: 20},
    }, {
      announcementStatus: 30,
      text: '公告结束',
      selected: false,
      condition: {announcementStatus: 30},
    },{
      announcementStatus: 40,
      text: '公告中止',
      selected: false,
      condition: {announcementStatus: 40},
    },
  ]
};